<template>
  <el-col :span="17" style="height: 100%">
    <div class="analysis">
      <div class="head">
        <div class="left">
          <div class="tab flex">
            <span class="tab_item" :class="{ active: selectIndex == 1 }" @click="selectIndex = 1">客户转化分析</span>
            <!-- v-if="!venderType" -->
            <span class="tab_item" :class="{ active: selectIndex == 3 }" @click="selectIndex = 3" style="margin-left: 28px">精准营销效果分析</span>
            <span class="tab_item" :class="{ active: selectIndex == 2 }" @click="selectChange" style="margin-left: 28px">催付效果分析</span>
          </div>
        </div>
        <date-box v-if="selectIndex == 2" @onDate="handleDate"></date-box>
        <date-box v-if="selectIndex == 3" @onDate="handleDate1"></date-box>
        <!-- Note:效果分析点击前往 -->
      </div>
      <div class="content-x" v-show="selectIndex == 1">
        <!-- 营销效果 -->
        <div class="roi-line">
          <div class="roi-wrap">
            <!-- <span style="font-size: 16px">ROI（投入产出比）</span>
            <span class="rate">{{ marketObj.roi }}</span> -->
            <!-- <span style="float:right;">
                <span @click="catchMore" >查看更多</span>
                   <el-popover
                 placement="top-end"
                 width="200"
                 trigger="hover"
                 content="最近一次精准营销的效果分析">
                <span class="icon" slot="reference">?</span>
            </el-popover>
           </span> -->
          </div>
        </div>
        <div class="effect-box">
          <el-row>
            <el-col :span="20">
              <div class="data-chat">
                <div class="effect-bg-wrap">
                  <div class="effect-bg-box">
                    <!-- <img
                      class="effect-bg"
                      src="@/assets/images/home/effect-bg.png"
                      alt
                    /> -->
                    <img class="effect-bg" src="@/assets/images/home/1366.png" alt />
                    <!-- <img
                      class="effect-bg-mini"
                      src="@/assets/images/home/effect-bg-mini.png"
                      alt
                    />  -->
                    <img class="effect-bg-mini" src="@/assets/images/home/1367.png" alt />
                    <div class="com-box send-num">
                      <div class="num">{{ homeData.enterStore }}</div>
                      <div class="text">进店人数</div>
                    </div>
                    <div class="com-box order-num">
                      <div class="num">{{ homeData.viewDetail }}</div>
                      <div class="text">浏览商详人数</div>
                    </div>
                    <div class="com-box pay-num">
                      <div class="num">{{ homeData.addToCart }}</div>
                      <div class="text">{{ venderType ? "加购人数" : "加购人数" }}</div>
                    </div>
                    <div class="com-box sucess-num">
                      <div class="num">{{ homeData.deal }}</div>
                      <div class="text">{{ venderType ? "成交人数" : "成交人数" }}</div>
                    </div>

                    <div class="com-box order-rate">
                      <div class="num">{{ homeData.viewRate || 0 }}</div>
                      <div class="text">浏览率</div>
                    </div>
                    <div class="com-box order-pay-rate">
                      <div class="num">{{ homeData.addToCartRate || 0 }}</div>
                      <div class="text">加购率</div>
                    </div>
                    <div class="com-box success-pay-rate">
                      <div class="num">{{ homeData.addToCartDealRate || 0 }}</div>
                      <div class="text">加购-成交率</div>
                    </div>
                    <div class="com-box pay-rate">
                      <div class="num">{{ homeData.dealConversionRate || 0 }}</div>
                      <div class="text">成交转化率</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="data-content">
                <div class="data-box">
                  <div class="more">
                    <span @click="catchMore">查看更多</span>
                    <el-popover placement="top-end" width="300" trigger="hover">
                      <div>1.仅统计近30天的数据</div>
                      <div>2.进店-浏览商详-加购-成交，代表用户行为的加深，而非严格漏斗关系，因此可能出现行为之间转化比例大于100%的情况</div>
                      <span class="icon" slot="reference">?</span>
                    </el-popover>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="content-x" v-show="selectIndex == 3">
        <!-- 营销效果 -->
        <div class="roi-line">
          <div class="roi-wrap" style="display: flex;margin-bottom: 24px;align-items: center;">
            ROI（投入产出比）<span style="color: #FE4D45;">{{ MarketingItem.roi }}</span>
            <div class="tip">
              <img
                src="@/assets/images/new_icon_waring_yellow.png"
                style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 1px 4px 0 0px;
                  "
              />注：最近一次精准营销的效果分析
            </div>
            <div
              class="more1"
              style="margin-left: auto;
              color: #666666;font-size: 14px;
              margin-right: 15px;
              cursor: pointer;
              line-height: 25px;"
            >
              <span @click="catchMore1">查看更多</span>
              <!-- <el-popover placement="top-end" width="300" trigger="hover">
                <div>1.仅统计近30天的数据</div>
                <div>2.进店-浏览商详-加购-成交，代表用户行为的加深，而非严格漏斗关系，因此可能出现行为之间转化比例大于100%的情况</div>
                <span class="icon" slot="reference">?</span>
              </el-popover> -->
            </div>
          </div>
        </div>
        <div class="effect-box">
          <el-row>
            <el-col :span="15">
              <div class="data-chat" style="left: 0;height: 355px;">
                <div class="effectBgWrap">
                  <div class="effectBgWrap-bg-box" style="height: 271px;">
                    <img class="effectBgWrap-bg" style="width: 100%;" src="@/assets/images/home/ld_1920.png" alt />
                    <img class="effectBgWrap-bg-mini" style="width: 100%;" src="@/assets/images/home/ld_1336.png" alt />
                    <div class="com-box send-num">
                      <div class="num">{{ MarketingItem.sendSubmitNum || 0 }}</div>
                      <div class="text">发送人数</div>
                    </div>
                    <div class="com-box order-num">
                      <div class="num">{{ MarketingItem.ordPins || 0 }}</div>
                      <div class="text">下单人数</div>
                    </div>
                    <div class="com-box pay-num">
                      <div class="num">{{ MarketingItem.payPins || 0 }}</div>
                      <div class="text">成交人数</div>
                    </div>

                    <div class="com-box order-rate">
                      <div class="num">{{ MarketingItem.ordRate || 0 }}</div>
                      <div class="text">下单转化率</div>
                    </div>
                    <div class="com-box order-pay-rate">
                      <div class="num">{{ MarketingItem.payOrdRate || 0 }}</div>
                      <div class="text">下单_付款转化率</div>
                    </div>
                    <div class="com-box success-pay-rate">
                      <div class="num">{{ MarketingItem.payRate || 0 }}</div>
                      <div class="text">付款转化率</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="9">
              <!-- <div class="data-content">
                <div class="data-box">
                  <div class="more">
                    <span @click="catchMore">查看更多</span>
                    <el-popover placement="top-end" width="300" trigger="hover">
                      <div>1.仅统计近30天的数据</div>
                      <div>2.进店-浏览商详-加购-成交，代表用户行为的加深，而非严格漏斗关系，因此可能出现行为之间转化比例大于100%的情况</div>
                      <span class="icon" slot="reference">?</span>
                    </el-popover>
                  </div>
                </div>
              </div> -->
              <div class="right-content">
                <div class="right-content—edit">
                  <span>商品详情UV</span>
                  <span class="num">{{ MarketingItem.followSkuNum || 0 }}</span>
                </div>
                <div class="right-content—edit">
                  <span>店铺首页UV</span>
                  <span class="num">{{ MarketingItem.followShopNum || 0 }}</span>
                </div>
                <div class="right-content—edit">
                  <span>付款金额</span>
                  <span class="num">{{ MarketingItem.payAmount || 0 }}</span>
                </div>
                <div class="right-content—edit">
                  <span>加购人数</span>
                  <span class="num">{{ MarketingItem.cartNum || 0 }}</span>
                </div>
                <div class="right-content—edit" style="width: 98%;">
                  <span>开卡会员购买人数</span>
                  <span class="num">{{ MarketingItem.cardPayPins || 0 }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="content" v-show="selectIndex == 2" v-if="goHome">
        <!-- 催付效果 -->

        <div class="payRemindData flex">
          <div class="roi-wrap">
            <span style="font-size: 16px; margin-right: 2px">ROI（投入产出比）</span>
            <span class="rate">{{ totalResult.roi }}</span>
            <!-- <span class="txt">(投入产出比)</span> -->
          </div>
          <div class="DataItem">
            <span class="num">{{ totalResult.recordCount }}</span>
            <span class="txt">催付订单数(单)</span>
          </div>
          <div class="DataItem">
            <span class="num">{{ totalResult.count }}</span>
            <span class="txt">挽回订单数(单)</span>
          </div>
          <div class="DataItem">
            <span class="num">{{ totalResult.money }}</span>
            <span class="txt">挽回金额(元)</span>
          </div>
          <div class="DataItem">
            <span class="num">{{ totalResult.result }}</span>
            <span class="txt">催付成功率(%)</span>
          </div>
        </div>
        <div ref="payRemindChart" class="chart"></div>
        <!-- <div class="tipSeven">近7天日期（不包含今天）</div> -->
      </div>
      <!-- Note:效果分析点击前往 -->
      <div v-if="!goHome && selectIndex != 1" class="goHome">
        <div>
          <img class="goHomeImage" src="@/assets/images/home/card.png" alt />
          <div class="goHomeZi">你还未开通自动催付，提升付款效率快人一步，请 <span class="goto" @click="goClick">点击前往</span> 去开通哦~</div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import { getRemindByTime, homeMarketing } from "@/api/notpayremind";
import { getMarketingLast, customerConversion, versionPermissions } from "@/api/homePage";
import echarts from "echarts";
import dateBox from "@/components/date-box";
export default {
  props: {
    version: null,
  },
  components: {
    dateBox,
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  data() {
    return {
      goUrl: "",
      homeData: {
        enterStore: "", //进店
        viewDetail: "", //浏览商详
        addToCart: "", //加购
        deal: "", //成交
        viewRate: "", //浏览率
        addToCartRate: "", //加购率
        addToCartDealRate: "", //加购-成交率
        addToCartDealRate: "", //成交转化率
      },
      goHome: true,
      navActive: 1,
      selectIndex: 1,
      myCharts: null,
      totalResult: {},
      date: [
        // "2019-11-10",
      ],
      chartData: {
        expectedData: [], // 挽回订单数
        actualData: [], // 挽回金额
      },
      marketObj: {},
      dateIndex: 2, // 0 昨天 1.近7天 2.近30天
      dateTime: 30,
      MarketingItem: {},
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart();
    //   window.addEventListener("resize", () => {
    //     this.myCharts.resize();
    //   });
    // });

    this.getEffectAnalysis();
    this.getPrecisonData();
    this.customerConversion();
    this.versionPermissions();
    this.homeMarketingData();
  },
  methods: {
    //是否有常规催付功能
    versionPermissions() {
      versionPermissions().then((res) => {
        let expedit = res.data.expediting;
        this.goHome = expedit;
        this.goUrl = res.data.expeditingUrl;
      });
    },
    //图表数据
    customerConversion() {
      customerConversion()
        .then((res) => {
          let echartsData = { ...res.data };
          this.homeData = echartsData;
        })
        .catch(() => {});
    },

    //点击前往
    goClick() {
      var url = "",
        index = 0;
      if (this.goHome) {
        url = "/orderCare/orderCare/expediting";
      } else {
        url = this.goUrl;
      }
      index = 1;
      this.bus.$emit("topHeader", {
        index: index,
        item: this.$store.state.route[index],
      });
      this.$router.push({
        path: url,
      });
    },
    catchMore1() {
      this.$router.push({
        // path: '/marketing/marketing/accurate_market',
        name: "accurate_market",
        params: {
          type: "home",
          strategyInstId: this.MarketingItem.strategyInstId,
        },
      });
    },
    catchMore() {
      var index = 3;
      var dateList = ["7", "15", "30"];
      this.bus.$emit("topHeader", { index: index, item: this.$store.state.route[index] });
      var marketObj = this.marketObj;
      this.$router.push({
        // path: '/marketing/marketing/accurate_market',
        name: "customer_transform_analysis",
        params: {
          homePage: true,
          day: dateList[this.dateIndex],
          strategyInstId: marketObj.strategyInstId,
          sendTime: marketObj.sendTime,
        },
      });
      // console.log("this.$store.state.route[index]", this.$store.state.route[index]);
      // setTimeout(() => {
      //   this.bus.$emit("topHeader", { index: index, item: this.$store.state.route[index]});
      // },20)
    },
    handleDate(index) {
      this.dateIndex = index;
      if (!this.venderType) {
        this.getEffectAnalysis();
      }
      this.getPrecisonData();
    },
    homeMarketingData() {
      homeMarketing({ days: this.dateTime }).then((res) => {
        this.MarketingItem = res.data;
        let payPins = res.data.payPins; // 成交/付款人数
        let ordPins = res.data.ordPins; // 下单人数
        let sendSubmitNum = res.data.sendSubmitNum; // 发送人数
        if (payPins && ordPins) {
          this.MarketingItem.payRate = ((payPins / sendSubmitNum) * 100).toFixed(2) + "%"; // 付款转化率
        }
        if (ordPins && sendSubmitNum) {
          this.MarketingItem.ordRate = ((ordPins / sendSubmitNum) * 100).toFixed(2) + "%"; // 下单转化率
        }
        if (payPins && ordPins) {
          this.MarketingItem.payOrdRate = ((payPins / ordPins) * 100).toFixed(2) + "%"; // 下单_付款转化率
        }
      });
    },
    handleDate1(index) {
      // console.log(index, 333333);
      if (index == 0) this.dateTime = 7;
      if (index == 1) this.dateTime = 15;
      if (index == 2) this.dateTime = 30;

      this.homeMarketingData();
    },

    /** 获取精准营销效果分析 */
    getPrecisonData() {
      var dateList = [7, 15, 30];
      var param = {
        days: dateList[this.dateIndex],
      };
      getMarketingLast(param).then((res) => {
        if (res.code == "1") {
          this.marketObj = res.data;
          var payPins = res.data.payPins; // 成交/付款人数
          var ordPins = res.data.ordPins; // 下单人数
          var sendSubmitNum = res.data.sendSubmitNum; // 发送人数

          if (payPins && ordPins) {
            this.marketObj.payRate = ((payPins / sendSubmitNum) * 100).toFixed(2) + "%"; // 付款转化率
          }
          if (ordPins && sendSubmitNum) {
            this.marketObj.ordRate = ((ordPins / sendSubmitNum) * 100).toFixed(2) + "%"; // 下单转化率
          }
          if (payPins && ordPins) {
            this.marketObj.payOrdRate = ((payPins / ordPins) * 100).toFixed(2) + "%"; // 下单_付款转化率
          }
        }
      });
    },

    getBeforeday(num) {
      var day = new Date();
      day.setTime(day.getTime() - num * 24 * 60 * 60 * 1000);
      var yy = day.getFullYear(),
        mm = day.getMonth() + 1,
        dd = day.getDate(),
        hh = day.getHours(),
        min = day.getMinutes(),
        ss = day.getSeconds();
      if (parseInt(mm) < 10) {
        mm = "0" + mm;
      }
      if (parseInt(dd) < 10) {
        dd = "0" + dd;
      }
      if (parseInt(hh) < 10) {
        hh = "0" + hh;
      }
      if (parseInt(min) < 10) {
        min = "0" + min;
      }
      if (parseInt(ss) < 10) {
        ss = "0" + ss;
      }
      return yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss;
    },

    /**  获取催付效果分析  */
    getEffectAnalysis() {
      var param = null;
      if (this.dateIndex == "0") {
        param = {
          timeRange: "sevenDays",
        };
      } else if (this.dateIndex == "1") {
        param = {
          timeRange: "range",
          // startTime: this.getBeforeday(0),
          // endTime: this.getBeforeday(6),
          endTime: this.getBeforeday(0),
          startTime: this.getBeforeday(15),
        };
      } else if (this.dateIndex == "2") {
        param = {
          timeRange: "month",
        };
      }

      getRemindByTime(param).then((res) => {
        if (res.code == "1") {
          this.totalResult = res.data.totalResult;
          var dataList = res.data.dataList;
          var date = [];
          var countList = []; // 挽回订单数
          var moneyList = []; // 挽回金额

          if (dataList.length > 0) {
            dataList.forEach((item) => {
              date.push(item.sendTime);
              countList.push(item.count);
              moneyList.push(item.money);
            });
            this.date = date;
            this.chartData = {
              expectedData: countList,
              actualData: moneyList,
            };
          }
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        }
      });
    },

    selectChange() {
      this.selectIndex = 2;
      this.$nextTick(() => {
        this.myCharts = echarts.init(this.$refs.payRemindChart);
        this.initChart();
      });
    },
    initChart() {
      // this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.chartData);
    },
    setOptions({ expectedData, actualData } = {}) {
      // expectedData = [22,25,31,40]
      // actualData = [12,75,41,62]
      // this.date = ['2020-28-04', '2020-04-02', '2020-04-02', '2020-04-02']

      let options = {
        // x轴配置
        xAxis: {
          data: this.date,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
        },
        // 直角坐标系内绘图网格
        grid: {
          left: 10,
          right: 10,
          bottom: 70,
          top: 30,
          containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
        },
        // 提示框组件
        tooltip: {
          trigger: "axis", //坐标轴触发
          axisPointer: {
            //指示器类型
            type: "cross",
          },
          padding: [5, 10],
        },
        // y轴配置
        yAxis: {
          axisTick: {
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        // 图例
        legend: {
          data: ["挽回订单", "挽回金额"],
          bottom: 17,
          left: 50,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: [
          {
            name: "挽回订单",
            itemStyle: {
              normal: {
                color: "#FE4D45",
                lineStyle: {
                  color: "#FE4D45",
                  width: 2,
                },
                areaStyle: {
                  //区域填充样式
                  color: "rgba(254,77,69,0.1)",
                },
              },
            },
            smooth: true,
            type: "line",
            data: expectedData,
            animationDuration: 100,
            animationEasing: "cubicInOut",
          },
          {
            name: "挽回金额",
            smooth: true,
            type: "line",
            itemStyle: {
              //折线拐点标志的样式。
              normal: {
                //默认样式
                color: "#4878FF",
                lineStyle: {
                  //线条样式
                  // color: '#3888fa',
                  width: 2,
                },
                areaStyle: {
                  //区域填充样式
                  color: "rgba(8,64,222,0.2)",
                },
              },
            },
            data: actualData, //数据
            animationDuration: 100, //初始动画时长
            animationEasing: "quadraticOut", //初始动画的缓动效果。
          },
        ],
      };
      this.myCharts.setOption(options);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
// .tipSeven {
//   font-size: 12px;
//   color: #666;
//   text-align: right;
//   // margin-top: 10px;
// }
.tip {
  padding: 10px;
  border-radius: 4px;
  background: #fffaee;
  margin-left: 5px;
}
.goHome {
  text-align: center;
  padding: 100px;
  .goHomeImage {
    width: 200px;
    height: 110px;
    opacity: 1;
  }
  .goHomeZi {
    color: #999;
    margin-top: 22px;
    font-size: 16px;
    .goto {
      color: #fe4d45;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.icon {
  display: inline-block;
  font-size: 12px;
  text-align: center;
  color: #ccc;
  line-height: 12px;
  border: 1px solid #ccc;
  width: 12px;
  height: 12px;
  border-radius: 12px;
  margin-left: 4px;
}

.flex {
  display: flex;
}

.analysis {
  height: 100%;
  //   @media screen and (max-width: 1540px) {
  // height: 90%;
  //   }
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;

  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px 0 25px;
    height: 54px;
    border-bottom: 1px solid #f6f6f6;

    .item.active {
      &::before {
        content: "";
        position: absolute;
        left: 2px;
        bottom: -4px;
        width: 12px;
        height: 2px;
        background-color: #ff536b;
        box-shadow: 0px 2px 3px rgba(255, 83, 107, 0.5);
        animation: opacity 0.3s ease-in;
      }

      .txt {
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }
    }

    @keyframes opacity {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    .left {
      color: #333;
      font-size: 16px;
      font-weight: Medium;
      height: 100%;

      .tab {
        height: 100%;

        .tab_item {
          line-height: 54px;
          font-weight: 800;
          opacity: 0.9;
          font-size: 16px;
          cursor: pointer;

          &:hover {
            color: #fe4d45;
          }
        }

        .active {
          border-bottom: 2px solid #fe4d45;
          color: #fe4d45;
          font-weight: bold;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;

      .li {
        margin-right: 27px;
        font-size: 14px;
        color: #999;
        font-weight: 400;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          color: #fe4d45;
        }

        &:last-child {
          margin: 0;
        }
      }

      .li.active {
        position: relative;
        color: #fe4d45;
        font-weight: bold;

        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -4px;
          transform: translateX(-50%);
          width: 24px;
          height: 2px;
          background: rgba(254, 77, 69, 1);
          box-shadow: 0px 2px 3px rgba(255, 83, 107, 0.5);
        }
      }
    }
  }

  .content-x {
    padding: 6px 0 32px 25px;

    .roi-line {
      color: #333;

      .roi-wrap {
        font-size: 16px;
        font-weight: 500;
      }

      .rate {
        color: #fe4d45;
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
      }
    }

    .effect-box {
      .data-chat {
        // height: 325px;
        height: 268px;
        left: -50px;

        @media screen and (max-width: 1366px) {
          left: -25px;
        }

        position: relative;

        .effect-bg-wrap {
          position: absolute;
          top: 50%;
          left: 62%;
          transform: translateY(-50%) translateX(-50%);

          .effect-bg-box {
            // width: 621px;
            height: 240px;
            position: relative;

            .effect-bg-mini {
              display: none;
            }

            .com-box {
              position: absolute;

              .num {
                font-size: 14px;
                color: #fe4d45;
              }

              .text {
                color: #000000;
                font-size: 12px;
              }
            }

            .send-num {
              top: 16px;
              left: -53px;
              font-weight: 500;
            }

            .order-num {
              left: -34px;
              top: 99px;
            }

            .pay-num {
              left: 35px;
              top: 181px;
            }

            .sucess-num {
              left: 79px;
              top: 264px;
            }

            .order-rate {
              left: 570px;
              top: 71px;
            }

            .order-pay-rate {
              left: 526px;
              top: 150px;
            }

            .success-pay-rate {
              left: 484px;
              top: 228px;
            }

            .pay-rate {
              top: 150px;
              right: -17px;
            }
          }
        }
        .effectBgWrap {
          width: 100%;
          padding-left: 20px;
          position: relative;
          .effectBgWrap-bg-box {
            width: 90%;
            display: flex;
            align-items: center;
            .com-box {
              position: absolute;
            }
          }
          .effectBgWrap-bg-mini {
            display: none;
          }
          .send-num {
            left: 6%;
            top: 9%;
          }
          .order-num {
            left: 6%;
            top: 44%;
          }
          .pay-num {
            left: 6%;
            top: 78%;
          }
          .order-rate {
            left: 70%;
            top: 26%;
          }
          .order-pay-rate {
            left: 64%;
            top: 60%;
          }
          .success-pay-rate {
            top: 42%;
            left: 85%;
          }

          .num {
            font-size: 16px !important;
            margin-bottom: 5px;
            color: #fe4d45;
          }
          .text {
            color: #666 !important;
          }
        }
      }

      .data-content {
        // border-left: 1px solid #f0f0f0;
        padding: 30px 0;

        .data-box {
          width: 70%;
          margin: 0 auto;
          // background-color: #f9f9f9;
          border-radius: 4px;
          padding-top: 37px;
          position: relative;

          .more {
            position: absolute;
            top: -70px;
            right: 0;
            color: #666666;
            font-size: 14px;
            cursor: pointer;

            span {
              vertical-align: middle;
            }

            .icon {
              display: inline-block;
              font-size: 12px;
              text-align: center;
              color: #ccc;
              line-height: 12px;
              border: 1px solid #ccc;
              width: 12px;
              height: 12px;
              border-radius: 12px;
              margin-left: 4px;
            }
          }

          .item {
            display: inline-block;
            width: 50%;
            padding-left: 10%;
            padding-bottom: 32px;

            .item-title {
              font-size: 13px;
              color: #999999;
            }

            .item-value {
              color: #333333;
              font-weight: bold;
              margin-top: 6px;
              font-size: 16px;
            }
          }
        }
      }
      .right-content {
        width: 350px;
        height: 281px;
        background: #f9f9f9;
        border-radius: 4px 4px 4px 4px;
        // margin-top: -70px;
        margin-left: 40px;
        padding: 32px 37px 37px 37px;
        display: flex;
        flex-wrap: wrap;

        .right-content—edit {
          width: 50%;
          color: #666666;
          height: 88px;
          span {
            display: block;
          }
          .num {
            font-size: 18px;
            color: #333;
            margin-top: 5px;
          }
        }
      }
    }
  }

  .content {
    display: flex;
    // align-items: center;
    box-sizing: border-box;
    padding: 0 50px 0 25px;
    height: 405px;
    flex-flow: column;

    .payRemindData {
      .roi-wrap {
        color: #333;
        font-size: 16px;
        font-weight: 500;
      }

      .rate {
        color: #fe4d45;
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
      }

      margin-top: 20px;
      // flex: 1;
      justify-content: space-between;

      .DataItem {
        display: flex;
        flex-direction: column;

        .num {
          color: #333333;
          font-family: DIN;
          font-size: 16px;
          font-weight: 600;
        }

        .txt {
          color: #666;
          // font-family: PingFang SC;
          font-size: 13px;
        }
      }
    }

    .chart {
      // flex: 1;
      height: 346px;
    }

    .marketing {
      flex: 1;
      box-sizing: border-box;
      padding-right: 30px;
      position: relative;
      height: 100%;

      .title {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        margin-top: 20px;
        color: #333;
        font-size: 18px;
        font-weight: 800;

        span:nth-child(2) {
          color: #999999;
          font-size: 12px;
          font-weight: 500;
          margin-right: 4px;
        }
      }

      .data {
        position: relative;
        width: 100%;
        height: 345px;

        .left {
          float: left;
          width: 50%;
          height: 90%;
          border-right: 1px dashed #b2b2b2;
          color: #666;
          font-size: 12px;

          .line {
            position: relative;
            box-sizing: border-box;

            &:first-child {
              border-top: 1px dashed #b2b2b2;
              padding-top: 4px;
            }

            &:nth-child(2) {
              margin-top: 35px;

              &::before {
                content: "";
                width: 82%;
                height: 1px;
                border-top: 1px dashed #b2b2b2;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                opacity: 0.6;
              }
            }

            &:nth-child(3) {
              margin-top: 20px;

              &::before {
                content: "";
                width: 82%;
                height: 1px;
                border-top: 1px dashed #b2b2b2;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                opacity: 0.6;
              }
            }

            &:nth-child(4) {
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 80px;

              &::before {
                content: "";
                width: 82%;
                height: 1px;
                border-top: 1px dashed #b2b2b2;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                opacity: 0.6;
              }
            }

            &:last-child {
              padding-top: 20px;
              height: 61px;
              border-bottom: 1px dashed #b2b2b2;
            }

            p {
              margin: 0;
            }

            span {
              color: #252c38;
              font-size: 16px;
              font-weight: 800;
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          float: right;
          width: 50%;
          height: 90%;

          .li {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            box-sizing: border-box;
            width: 50%;
            height: 56px;
            position: relative;
            color: #fe4d45;
            font-size: 16px;
            font-weight: bold;

            .bfb {
              margin-top: 8px;
            }

            &:nth-child(1) {
              margin-top: 44px;

              &::before {
                content: "";
                width: 36%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                border-top: 1px dashed #b2b2b2;
                border-right: 1px dashed #b2b2b2;
                opacity: 0.6;
              }

              .txt::before {
                content: "";
                position: absolute;
                left: -37px;
                bottom: -12px;
                width: 28px;
                border-bottom: 1px dashed #b2b2b2;
              }
            }

            &:nth-child(2) {
              padding-right: 36px;

              &::before {
                content: "";
                width: 36%;
                height: 100%;
                position: absolute;
                left: -30px;
                top: 0;
                border-top: 1px dashed #b2b2b2;
                border-right: 1px dashed #b2b2b2;
                opacity: 0.6;
              }

              .txt::before {
                content: "";
                position: absolute;
                left: -44px;
                bottom: -12px;
                width: 28px;
                border-bottom: 1px dashed #b2b2b2;
              }
            }

            &:nth-child(3) {
              padding-right: 58px;

              &::before {
                content: "";
                width: 38%;
                height: 100%;
                position: absolute;
                left: -63px;
                top: 0;
                border-top: 1px dashed #b2b2b2;
                border-right: 1px dashed #b2b2b2;
                opacity: 0.6;
              }

              .txt::before {
                content: "";
                position: absolute;
                left: -107px;
                bottom: -13px;
                width: 82px;
                border-bottom: 1px dashed #b2b2b2;
              }
            }

            .txt {
              position: relative;
              color: #666;
              font-size: 12px;
              font-weight: bold;
            }
          }
        }

        .imgbox {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          img {
            margin-bottom: 2px;
          }
        }
      }
    }

    .detailsData {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      box-sizing: border-box;
      padding: 0 0 0 68px;
      margin: 0;
      list-style: none;
      border-left: 1px solid #f3f3f3;

      .item {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-bottom: 22px;

        &:last-child {
          margin: 0;
        }

        .txt {
          font-size: 13px;
          color: #666;
        }

        .num {
          font-size: 16px;
          color: #333;
        }
      }
    }
  }

  .content.padding {
    padding: 0 36px;
  }

  @media screen and (max-width: 1680px) {
    .content-x {
      padding: 6px 0 0 25px;
      // margin-bottom: -20px;

      .effect-box {
        .data-chat {
          .effect-bg-wrap {
            left: 65%;
            .effect-bg-box {
              .effect-bg-mini {
                display: block;
              }

              .effect-bg {
                display: none;
              }

              .order-rate {
                left: 644px;
              }

              .order-pay-rate {
                left: 601px;
              }

              .pay-rate {
                // left: 450px;
                right: -2px;
              }
              .success-pay-rate {
                left: 560px;
              }
            }
          }
          // .effectBgWrap {
          //   left: 4%;
          //   .send-num {
          //     left: 16px !important;
          //     top: 20px !important;
          //   }
          //   .order-num {
          //     left: 16px !important;
          //     top: 88px !important;
          //   }
          //   .pay-num {
          //     left: 16px !important;
          //     top: 158px !important;
          //   }
          //   .order-rate {
          //     left: 326px !important;
          //     top: 54px !important;
          //   }
          //   .order-pay-rate {
          //     left: 271px !important;
          //     top: 115px !important;
          //   }
          //   .success-pay-rate {
          //     top: 86px !important;
          //     left: 398px !important;
          //   }
          //   .com-box {
          //     .num {
          //     }
          //   }
          // }
          .effectBgWrap {
            min-width: 653px;
            .effectBgWrap-bg {
              display: none;
            }
            .effectBgWrap-bg-mini {
              display: block;
            }
            .order-rate {
              left: 66%;
            }
            .order-pay-rate {
              left: 57%;
            }
          }
        }
        .right-content {
          width: 268px;
          min-width: 208px;
          height: 240px;
          margin-left: 100px;
          @media screen and (max-width: 1500px) {
            width: 248px;
            min-width: 208px;
            height: 240px;
            margin-left: 100px;
          }
          @media screen and (max-width: 1400px) {
            width: 208px;
            min-width: 208px;
            height: 240px;
            margin-left: 100px;
          }
          .right-content—edit {
            height: 69px;
          }
        }
        .data-content {
          .data-box {
            width: 75%;

            .item {
              padding-left: 5%;
            }
          }
        }
      }
    }
  }

  // @media screen and (min-width: 1842px) and (max-width: 1900px) {
  //   .content {
  //     .marketing {
  //       .data {
  //         .right {
  //           .li {
  //             &:nth-child(1) {
  //               margin-top: 44px;
  //               &::before {
  //                 content: "";
  //                 width: 36%;
  //                 left: 0;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -33px;
  //                 bottom: -12px;
  //                 width: 28px;
  //               }
  //             }
  //             &:nth-child(2) {
  //               padding-right: 36px;
  //               &::before {
  //                 width: 36%;
  //                 left: -30px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -38px;
  //                 bottom: -12px;
  //                 width: 28px;
  //               }
  //             }
  //             &:nth-child(3) {
  //               padding-right: 58px;
  //               &::before {
  //                 width: 38%;
  //                 left: -63px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -101px;
  //                 bottom: -13px;
  //                 width: 82px;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // @media screen and (min-width: 1790px) and (max-width: 1842px) {
  //   .content {
  //     .marketing {
  //       .data {
  //         .right {
  //           .li {
  //             &:nth-child(1) {
  //               margin-top: 44px;
  //               &::before {
  //                 content: "";
  //                 width: 36%;
  //                 left: 0;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -30px;
  //                 bottom: -12px;
  //                 width: 28px;
  //               }
  //             }
  //             &:nth-child(2) {
  //               padding-right: 36px;
  //               &::before {
  //                 width: 36%;
  //                 left: -30px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -38px;
  //                 bottom: -12px;
  //                 width: 28px;
  //               }
  //             }
  //             &:nth-child(3) {
  //               padding-right: 58px;
  //               &::before {
  //                 width: 38%;
  //                 left: -63px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -92px;
  //                 bottom: 3px;
  //                 width: 74px;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //     .detailsData {
  //     }
  //   }
  // }
  // @media screen and (min-width: 1670px) and (max-width: 1790px) {
  //   .content {
  //     .marketing {
  //       .data {
  //         .right {
  //           .li {
  //             &:nth-child(1) {
  //               margin-top: 44px;
  //               &::before {
  //                 content: "";
  //                 width: 36%;
  //                 left: 0;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -33px;
  //                 bottom: -12px;
  //                 width: 38px;
  //               }
  //             }
  //             &:nth-child(2) {
  //               padding-right: 36px;
  //               &::before {
  //                 width: 36%;
  //                 left: -30px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -38px;
  //                 bottom: -12px;
  //                 width: 35px;
  //               }
  //             }
  //             &:nth-child(3) {
  //               padding-right: 58px;
  //               &::before {
  //                 width: 38%;
  //                 left: -63px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -92px;
  //                 bottom: 3px;
  //                 width: 70px;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // // @media screen and (min-width: 1600px) and (max-width: 1720px) {
  // @media screen and (max-width: 1670px) {
  //   .content {
  //     padding: 0px 38px 0 38px;
  //     .marketing {
  //       min-width: 415px;
  //       .data {
  //         .right {
  //           .li {
  //             &:nth-child(1) {
  //               margin-top: 44px;
  //               &::before {
  //                 content: "";
  //                 width: 36%;
  //                 left: 0;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -32px;
  //                 bottom: -12px;
  //                 width: 38px;
  //               }
  //             }
  //             &:nth-child(2) {
  //               padding-right: 36px;
  //               &::before {
  //                 width: 36%;
  //                 left: -30px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -33px;
  //                 bottom: -12px;
  //                 width: 35px;
  //               }
  //             }
  //             &:nth-child(3) {
  //               padding-right: 58px;
  //               &::before {
  //                 width: 38%;
  //                 left: -63px;
  //                 top: 0;
  //               }
  //               .txt::before {
  //                 left: -84px;
  //                 bottom: 3px;
  //                 width: 60px;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //     .detailsData {
  //       padding: 0px 0 0 30px;
  //       .item {
  //         margin-bottom: 14px;
  //         .txt {
  //           font-size: 12px;
  //         }
  //         .num {
  //           font-size: 14px;
  //         }
  //       }
  //     }
  //   }
  // }
  // @media screen and (min-width: 0) and (max-width: 1900px) {
  //   .content {
  //     .marketing {
  //       .data {
  //         .imgbox {
  //           .img1 {
  //             width: 100%;
  //           }
  //           .img2 {
  //             width: 70%;
  //           }
  //           .img3 {
  //             width: 47%;
  //           }
  //           .img4 {
  //             width: 26%;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
